// Allows letters, spaces, hyphens, numbers, and apostrophes. For first/last name fields.
function sanitizeTightTextInput(value: string | undefined): string {
  if (!value) return value ?? '';
  const cleanChars = value.replaceAll(/[^a-zA-Z0-9\s\-']/g, ' ');
  return cleanUpSpaces(cleanChars);
}

// Allows letters, digits, spaces, and common sentence punctuation. For open text fields.
function sanitizeTextInput(value: string | undefined): string {
  if (!value) return value ?? '';
  const cleanChars = value.replaceAll(/[^a-zA-Z0-9\s.,!?'"\-:;]/g, ' ');
  return cleanUpSpaces(cleanChars);
}

// Allows letters, digits, whitespace, and characters confirmed present in legal agreement text.
// Strips anything outside: a-z A-Z 0-9 whitespace . , / ' - ( )
function sanitizeLooseTextInput(value: string | undefined): string {
  if (!value) return value ?? '';
  const cleanChars = value.replaceAll(/[^a-zA-Z0-9\s.,!?'":;/’()-]/g, ' ');
  return cleanUpSpaces(cleanChars);
}

function cleanUpSpaces(value: string): string {
  return value.replaceAll(/[ \u00A0]+/g, ' ').trim();
}

export { sanitizeTightTextInput, sanitizeTextInput, sanitizeLooseTextInput };
